import(/* webpackMode: "eager", webpackExports: ["CameraLab"] */ "/home/runner/work/udata-site/udata-site/components/Navigation/Camera/CameraLab.tsx");
